import React from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { FaCode, FaSpinner, FaSync, FaStop } from 'react-icons/fa';
import Spinner from '../Spinner';
import ExecutionLogsWindow from '../ExecutionLogsWindow';
import { safeRenderValue } from './utils/logsUtils';

const LiveLogsCard = ({
  executionArn,
  restoredFromLogs,
  liveLogs,
  fetchingLogs,
  logsPollingActive,
  executionStatus,
  statusPollingActive,
  stoppingExecution,
  agentId,
  agentType,
  onManualRefresh,
  onStopExecution
}) => {
  if (!executionArn && !restoredFromLogs) {
    return null;
  }

  return (
    <Card className="logs-card">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="section-heading">
            <FaCode className="me-2" />
            Live Execution Logs
            {fetchingLogs && logsPollingActive && <FaSpinner className="fa-spin ms-2" />}
            {!logsPollingActive && (
              <Badge bg="secondary" className="ms-2">
                {restoredFromLogs ? 'Historical Data' : 'Monitoring Stopped'}
              </Badge>
            )}
          </h2>
          <div className="d-flex gap-2">
            {restoredFromLogs && (
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={onManualRefresh}
                disabled={fetchingLogs}
                title="Refresh to get the latest execution state"
              >
                {fetchingLogs ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Refreshing...
                  </>
                ) : (
                  <>
                    <FaSync className="me-2" />
                    Refresh Logs
                  </>
                )}
              </Button>
            )}
            
            {executionArn && statusPollingActive && 
             executionStatus?.status !== 'SUCCEEDED' && 
             executionStatus?.status !== 'FAILED' && (
              <Button 
                variant="danger" 
                size="sm"
                onClick={onStopExecution}
                disabled={stoppingExecution}
                title="Stop the current execution"
              >
                {stoppingExecution ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Stopping...
                  </>
                ) : (
                  <>
                    <FaStop className="me-2" />
                    Stop Execution
                  </>
                )}
              </Button>
            )}
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        <div className="logs-content">
          {restoredFromLogs && liveLogs ? (
            <div className="p-4">
              <div className="bg-light p-4 rounded" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <pre className="mb-0" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {safeRenderValue(liveLogs)}
                </pre>
              </div>
            </div>
          ) : (
            <ExecutionLogsWindow 
              executionArn={executionArn}
              agentId={agentId}
              targetType={agentType}
              result={liveLogs}
              refreshInterval={5000}
            />
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default LiveLogsCard;
